import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useSelector, useDispatch } from "react-redux";

import { MenuItem } from "../../menu-item";
import MenuRight from "../../../atoms/icons/menu-right";

import { OPEN_SEARCHBAR, OPEN_HAMBURGER_MENU, setNewNotification } from "../../../store/actions";
import Logo from "../../../atoms/icons/logo";
import HamburgerMenus from "../hamburger-menus";
import StickyNavbar from "../../../molecules/sticky-navbar";
import HeaderRight from "../header-right";

import "./mobile-header.m.css";
import Modal from "../../../atoms/modal";
import NotificationBox from "../../../molecules/notification-box";
import CokHeader from "../cok-header";

const MobileHeader = ({
  isHardcodedHeader,
  showSecondaryHeader = true,
  showStickyNavbar = false
}) => {
  const dispatch = useDispatch();
  // const notificationsData = useSelector((state) => get(state, ["notificationList"], {}));

  const getState = useSelector((state) => state);
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], ""));

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const [showModal, setShowModal] = useState(false);
  const notificationList = get(getState, "notificationList");

  const openModal = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const toggleHandler = () => {
    dispatch({
      type: OPEN_HAMBURGER_MENU,
      isHamburgerMenuOpen: !isHamburgerMenuOpen
    });
    dispatch({
      type: OPEN_SEARCHBAR,
      isSearchBarOpen: false
    });
  };

  const primaryBarRef = useRef(null);
  const blackBarRef = useRef(null);
  const whiteMenuRef = useRef(null);
  const secondaryStackRef = useRef(null);
  const lastScrollYRef = useRef(0);
  const collapseOffsetRef = useRef(0);
  const secondaryVisible = showSecondaryHeader;
  const [primaryHeight, setPrimaryHeight] = useState(0);
  const [secondaryHeight, setSecondaryHeight] = useState(0);
  const totalHeight = primaryHeight + secondaryHeight;

  const applyHeaderOffset = (nextOffset, currentScrollY = 0, forceHidden = false, forceShowAll = false) => {
    const clampedOffset = Math.max(0, Math.min(nextOffset, totalHeight));
    if (forceShowAll) {
      if (primaryBarRef.current) {
        primaryBarRef.current.style.transform = "translateY(0)";
      }

      if (secondaryStackRef.current) {
        secondaryStackRef.current.style.transform = `translateY(${primaryHeight}px)`;
      }
      return;
    }

    let primaryOffset = primaryHeight;
    const blueRevealStart = primaryHeight * 2;

    if (!forceHidden && currentScrollY <= blueRevealStart) {
      const revealProgress = Math.max(0, Math.min(currentScrollY / blueRevealStart, 1));
      primaryOffset = revealProgress * primaryHeight;
    }

    const blueVisibleHeight = Math.max(primaryHeight - primaryOffset, 0);
    const secondaryHiddenOffset = forceHidden ? secondaryHeight : Math.max(clampedOffset - primaryHeight, 0);
    const secondaryTranslateY = blueVisibleHeight - secondaryHiddenOffset;

    if (primaryBarRef.current) {
      primaryBarRef.current.style.transform = `translateY(-${primaryOffset}px)`;
    }

    if (secondaryStackRef.current) {
      secondaryStackRef.current.style.transform = `translateY(${secondaryTranslateY}px)`;
    }
  };

  useLayoutEffect(() => {
    if (typeof window === "undefined") return undefined;

    const measureHeights = () => {
      const nextPrimaryHeight = primaryBarRef.current?.offsetHeight || 0;
      const blackBarHeight = blackBarRef.current?.offsetHeight || 0;
      const whiteBarHeight = whiteMenuRef.current?.offsetHeight || 32;

      setPrimaryHeight(nextPrimaryHeight);
      setSecondaryHeight(secondaryVisible ? blackBarHeight + whiteBarHeight : 0);
    };

    measureHeights();
    window.addEventListener("resize", measureHeights);

    return () => {
      window.removeEventListener("resize", measureHeights);
    };
  }, [secondaryVisible, primaryMenus.length, secondaryMenus.length]);

  useLayoutEffect(() => {
    const clampedOffset = Math.min(collapseOffsetRef.current, totalHeight);
    collapseOffsetRef.current = clampedOffset;
    applyHeaderOffset(clampedOffset, lastScrollYRef.current);
  }, [primaryHeight, secondaryHeight]);

  useLayoutEffect(() => {
    if (typeof window === "undefined") return undefined;
    const topBarContainer = document.querySelector(".top-bar-container");
    if (!topBarContainer) return undefined;

    topBarContainer.style.height = `${totalHeight}px`;
    topBarContainer.style.minHeight = `${totalHeight}px`;

    return () => {
      topBarContainer.style.height = "";
      topBarContainer.style.minHeight = "";
    };
  }, [totalHeight]);

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    let frameId = null;

    const handleScroll = () => {
      const currentScrollY = window.scrollY || 0;

      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      frameId = window.requestAnimationFrame(() => {
        const isNearTop = currentScrollY <= Math.max(primaryHeight, 24);
        const isAtBottom =
          window.innerHeight + currentScrollY >= document.documentElement.scrollHeight - 100;
        let hideForStoryFollowBar = false;
        if (pageType === "story-page") {
          const storySection = document.querySelector(".story-section");
          const taboolaAd = document.querySelector("#ad-wrapper-taboola");
          const followBarSticky = !!document.querySelector(".sticky-div.sticky");
          const storyTop = storySection?.getBoundingClientRect().top;
          const taboolaTop = taboolaAd?.getBoundingClientRect().top;
          const isInsideStory =
            storyTop !== undefined &&
            storyTop <= primaryHeight &&
            (taboolaTop === undefined || taboolaTop > primaryHeight);

          hideForStoryFollowBar = currentScrollY > primaryHeight && isInsideStory && followBarSticky;
        }

        if (isNearTop) {
          collapseOffsetRef.current = 0;
          lastScrollYRef.current = currentScrollY;
          applyHeaderOffset(0, currentScrollY, false, true);
          frameId = null;
          return;
        }

        const scrollDelta = currentScrollY - lastScrollYRef.current;
        const nextOffset = collapseOffsetRef.current + scrollDelta;

        collapseOffsetRef.current = isAtBottom ? 0 : Math.max(0, Math.min(nextOffset, totalHeight));
        lastScrollYRef.current = currentScrollY;
        applyHeaderOffset(collapseOffsetRef.current, currentScrollY, hideForStoryFollowBar, isAtBottom);
        frameId = null;
      });
    };

    lastScrollYRef.current = window.scrollY || 0;
    collapseOffsetRef.current = Math.min(lastScrollYRef.current, totalHeight);
    applyHeaderOffset(collapseOffsetRef.current, lastScrollYRef.current, false, false);

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll);
    handleScroll();

    return () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [pageType, primaryHeight, secondaryHeight, totalHeight]);

  useEffect(() => {
    if (showModal) {
      window.localStorage.setItem("latestNotificationCreatedAt", notificationList[0]?.createdAt);
      dispatch(setNewNotification(false));
    }
  }, [showModal]);

  const getPrimaryMenus = () => {
    return (
      <div styleName="primary-menus">
        {primaryMenus.slice(0, 10).map((item, index) => (
          <div key={index} styleName="primary-menu-item">
            <MenuItem
              changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
              changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
              item={item}
              menuStyle="menu-link"
              toggleHandler={() =>
                dispatch({
                  type: OPEN_SEARCHBAR,
                  isSearchBarOpen: false
                })
              }
            />
          </div>
        ))}
      </div>
    );
  };

  if (isHardcodedHeader == "cok2025") {
    return <CokHeader toggleHandler={toggleHandler} />;
  }

  return (
    <>
      <div styleName="header" id="mob-header">
        <div
          ref={primaryBarRef}
          styleName="primary"
        >
          <div>
            <Link href="/" styleName="logo">
              <Logo height="56" width="64.63" />
            </Link>
          </div>

          <div styleName="primary-right-wrapper">
            <HeaderRight openNotificationModal={openModal} />
          </div>
        </div>
        {showModal && (
          <Modal onClose={closeModal} isOpen={showModal}>
            <NotificationBox closeBtnHandler={closeModal} />
          </Modal>
        )}
        {secondaryVisible && (
          <div ref={secondaryStackRef} styleName="secondary-stack">
            <div ref={blackBarRef} styleName="secondary" className="primary-menu">
              <div>{getPrimaryMenus()}</div>
            </div>
            <div ref={whiteMenuRef} styleName="menu-wrapper secondary-menu-wrapper" className="secondary-menu">
              {secondaryMenus.slice(0, 10).map((item, index) => (
                <React.Fragment key={index}>
                  <div styleName="secondary-menu-item">
                    <MenuRight />
                    <MenuItem
                      item={item}
                      key={index}
                      type="secondary"
                      menuStyle="menu-link"
                      changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
                      changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
                    />
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        )}
      </div>
      <HamburgerMenus />
      <StickyNavbar showStickyNavbar={showStickyNavbar} onMenuToggle={() => toggleHandler()} />
    </>
  );
};

export default MobileHeader;
